module.exports = {
	"id": "abt524",
	"enabled": true,
	"type": "standard",
	"split": 2,
	"dateRange": [
		{
			"start": "2016-04-28T11:00:00-05:00",
			"end": "2016-05-05T23:59:59-05:00"
		}
	],
	"cookieExpiration": "2016-05-15T23:59:59-05:00",
	"evar": {
		"number": 66,
		"qa": 68,
		"name": "plp_sponsored_skus"
	},
	"pageCriteria": {
		"pageType": [
			"browse,list,category",
			"browse,list,search,results"
		]
	},
	"deviceSize": [
		"s",
		"m",
		"l"
	],
	"buckets": [
		"11",
		"12",
		"13",
		"14",
		"15",
		"16",
		"17",
		"18",
		"19",
		"20"
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-tests/abt524/config.json
 ** module id = 35
 ** module chunks = 2
 **/